import React, { useState } from "react";
import { Avatar, Button, Card, Checkbox, Flex, Input, Modal } from "antd";
import { UserOutlined, RightOutlined } from "@ant-design/icons";
import {
  ClockIcon,
  CommentPlusIcon,
  Downolad1Icon,
  FileUploadIcon,
  bagIcon,
  bilidingIcon,
  bookIcon,
  departmentsIcon,
  mapIcon,
  phone1Icon,
  walletIcon,
} from "../../assets";
import "../../styles/candidate-card.css";
import ConfirmationModal from "../modal/ConfirmationModal";
import Toast from "../Toast/Toast";
import { post } from "../../lib/Api";
import dayjs from "dayjs";
const s3URL = process.env.REACT_APP_AWS_IMAGE_URL;

const CandidateCard = ({
  candidate,
  handleVisibleDetails,
  isSelected,
  onSelectChange,
  fetchData,
}) => {
  const [loading, setLoading] = useState(false);
  const [isCvDownloadModalOpen, setIsCvDownloadModalOpen] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [showPhoneNumber, setShowPhoneNumber] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(candidate?.phone_number);

  const handlePhoneNumberClick = async () => {
    if (phoneNumber) {
      setShowPhoneNumber(!showPhoneNumber);
    } else {
      try {
        setLoading(true);
        const data = {
          candidate_profile_id: candidate?.id,
          credit_type: "phone_number",
        };
        const response = await post("user/credits-used", data, "", true);
        if (response?.status === true) {
          setPhoneNumber(response?.data?.phone_number);
          setShowPhoneNumber(true);
        } else {
          Toast({ message: response?.message, type: "error" });
        }
      } catch (error) {
        console.error("Failed to fetch phone number", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleDownloadCV = async () => {
    try {
      const data = {
        candidate_profile_id: candidate?.id,
      };
      const response = await post("candidate/cv-download", data, "", true);
      if (response?.status === true) {
        const url = s3URL + response?.data?.cv_path;
        window.open(url, "_blank");
        setIsCvDownloadModalOpen(false);
      } else {
        Toast({ message: response?.message, type: "error" });
        setLoading(false);
      }
    } catch (error) {
      console.error("Failed to Download CV", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseCommentModal = () => {
    setShowCommentModal(false);
    setCommentText("");
  };

  const handlePostComment = async () => {
    setLoading(true);
    const data = {
      candidate_profile_id: candidate?.id,
      note_description: commentText,
    };
    try {
      const response = await post("candidate/notes-create", data, "", true);
      if (response?.status === true) {
        Toast({ message: response?.message, type: "success" });
        setShowCommentModal(false);
        fetchData();
        setCommentText("");
        setLoading(false);
      } else {
        Toast({ message: response?.message, type: "error" });
        setLoading(false);
      }
    } catch (error) {
      console.error("Failed to fetch candidates", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Card
        title={
          <>
            <Flex
              justify="space-between"
              align="center"
              className="candidate-user-info"
            >
              <Checkbox checked={isSelected} onChange={onSelectChange}>
                <div onClick={() => handleVisibleDetails(candidate)}>
                  <Avatar icon={<UserOutlined />} />
                  <h2>{candidate.name}</h2> <RightOutlined />
                </div>
              </Checkbox>
            </Flex>
            <div className="candidate-user-bio">
              <div className="user-bio-details">
                <div className="user-bio-list">
                  <img src={bagIcon} alt="" />
                  <span>{candidate.experience} year</span>
                </div>
                <div className="user-bio-list">
                  <img src={walletIcon} alt="" />
                  <span>₹ {candidate?.annual_salary}</span>
                </div>
                <div className="user-bio-list">
                  <img src={mapIcon} alt="" />
                  <span>
                    {candidate?.city}, {candidate?.state}
                  </span>
                </div>
              </div>
            </div>
            <div className="user-bio-info">
              <div className="user-bio-labels">
                <div className="bio-item">
                  <img src={bookIcon} alt="" />
                  <span>Education : </span>
                  <span className="user-bio-values">
                    {candidate?.qualification ? candidate?.qualification : "N/A"}
                  </span>
                </div>
                <div className="bio-item">
                  <img src={bilidingIcon} alt="" />
                  <span>Current Company : </span>
                  <span className="user-bio-values">
                    {candidate?.current_company ? candidate?.current_company : "N/A"}
                  </span>
                </div>
                <div className="bio-item">
                  <img src={departmentsIcon} alt="" />
                  <span>Designation : </span>
                  <span className="user-bio-values">
                    {candidate?.designation ? candidate?.designation : "N/A"}
                  </span>
                </div>
                <div className="bio-item">
                  <img src={bookIcon} alt="" />
                  <span>Previous Company : </span>
                  <span className="user-bio-values">
                    {candidate?.previous_company ? candidate?.previous_company : "N/A"}
                  </span>
                </div>
                <div className="bio-item">
                  <img src={mapIcon} alt="" />
                  <span>Preferred Location : </span>
                  <span className="user-bio-values">
                    {candidate?.preffered_location_name?.length > 0 ? candidate?.preffered_location_name?.join(", ") : "N/A"}
                  </span>
                </div>
                <div className="bio-item">
                  <img src={departmentsIcon} alt="" />
                  <span>Skills : </span>
                  <span className="user-bio-values">
                    {candidate?.skills_name?.length > 0 ? candidate?.skills_name?.join(", ") : "N/A"}
                  </span>
                </div>
              </div>
            </div>
          </>
        }
        className="candidate-card"
      >
        <Flex
          gap="small"
          wrap
          justify="flex-end"
          className="candidate-button-group"
        >
          <Button
            type="default"
            size="large"
            icon={<img src={phone1Icon} alt="icon" />}
            onClick={handlePhoneNumberClick}
            loading={loading}
          >
            {phoneNumber ? phoneNumber : "View Phone Number"}
          </Button>
          {/* <Button
            type="default"
            size="large"
            icon={<img src={mail1Icon} alt="icon" />}
          >
            View Email
          </Button> */}
          <Button
            type="default"
            size="large"
            icon={<img src={Downolad1Icon} alt="icon" />}
            onClick={() => {
              setIsCvDownloadModalOpen(true);
            }}
          >
            Download CV
          </Button>
        </Flex>
        <Flex justify="space-between" align="center" className="card-footer">
          <ul>
            {/* <li>
              <img src={UnlockIcon} alt="" /> 50 unlocks
            </li> */}
            {/* <li>
              <img src={UnlockIcon} alt="" /> Profile unlocked by me,{" "}
              {candidate.lastActive}
            </li> */}
          </ul>
          <ul style={{ flexWrap: "nowrap" }}>
            {candidate?.cv && (
              <li>
                <img src={FileUploadIcon} alt="" /> CV attached
              </li>
            )}
            <li>
              <img src={ClockIcon} alt="" /> Active on{" "}
              {candidate.lastActiveDate
                ? dayjs(candidate.lastActiveDate).format("DD-MM-YYYY")
                : "N/A"}
            </li>
            <li>
              <Button
                type="link"
                block
                icon={<img src={CommentPlusIcon} alt="icon" />}
                onClick={() => {
                  setShowCommentModal(true);
                }}
              >
                Comment
              </Button>
            </li>
          </ul>
        </Flex>
      </Card>
      <ConfirmationModal
        isOpen={isCvDownloadModalOpen}
        onConfirm={() => {
          handleDownloadCV();
        }}
        onCancel={() => setIsCvDownloadModalOpen(false)}
        loading={loading}
        title="Confirm Download"
        message="Are you sure you want to download this candidate's CV?"
      />

      <Modal
        title={`Comment for ${candidate.name}`}
        centered
        open={showCommentModal}
        onCancel={handleCloseCommentModal}
        footer={[
          <Button
            key="cancel"
            className="create-modal-cancel-button"
            onClick={() => {
              setShowCommentModal(false);
            }}
          >
            Cancel
          </Button>,
          <Button
            key="confirm"
            className="create-modal-confirm-button"
            onClick={handlePostComment}
            loading={loading}
            disabled={loading || !commentText}
          >
            Post
          </Button>,
        ]}
      >
        <Input.TextArea
          value={commentText}
          onChange={(e) => setCommentText(e.target.value)}
          placeholder="Write comment here..."
          autoSize={{ minRows: 3, maxRows: 8 }}
        />
      </Modal>

      {/* <ToastContainer /> */}
    </>
  );
};

export default CandidateCard;
